<div *ngIf="products$ | async as products" class="dealer-acquisition">
  <h2 class="dealer-acquisition-title">{{title$ | async}}</h2>
  <div class="dealer-acquisition-products">
    <gen-dealer-acquisition-product *ngFor="let product of products" [product]="product"></gen-dealer-acquisition-product>
  </div>
</div>